import {Component, OnInit, ViewChild} from '@angular/core';
import {Appel} from '../../../modele/appel';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ToastrService} from 'ngx-toastr';
import {AppelService} from '../../../service/appel.service';
import {Conversation} from '../../../modele/conversation';
import {ActivatedRoute} from '@angular/router';
import {ConfigService} from '../../../service/config.service';
import {DatePipe, Location} from '@angular/common';

@Component({
  selector: 'app-ajoutappel',
  templateUrl: './ajoutappel.component.html',
  styleUrls: ['./ajoutappel.component.css']
})
export class AjoutappelComponent implements OnInit {
  listeConversation;
  myDate;
  myTime;
  idProspect: number;
  appel;
  NiveauInters;
  DateDern;

  conversation: Conversation = {Conver_Date: null, Conver_Echange: null, Conver_heure: null, Conver_Id: null,
    Conver_Relance: null, Conver_Type: null, Conver_AppelId: null, Conver_UserId: null, Conver_Interresse: null}

  constructor(private datePipe: DatePipe,
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private location: Location,
              private appelService: AppelService,
              private configService: ConfigService) { }


  ngOnInit() {
    this.configService.recherche = 1;
    this.loadConversation();
  }

  loadConversation() {
    this.configService.recherche = 1;
    const id = this.route.snapshot.paramMap.get('id');
    if (id !== '0') {
      this.appelService.readoneAppel(id).subscribe(a => this.appel = a);
      this.idProspect = Number(id);

      this.appelService.readConversation(id).subscribe(conversation => {
        this.listeConversation = conversation;
        console.log('tototototototo', this.listeConversation);
      });
      this.conversation = {Conver_Date: null, Conver_Echange: null, Conver_heure: null, Conver_Id: null,
        Conver_Relance: null, Conver_Type: null, Conver_AppelId: null, Conver_UserId: null, Conver_Interresse: null}
      this.chargeDateTime();
      this.conversation.Conver_UserId = this.configService.varIdUtilisateur;
      this.conversation.Conver_AppelId = this.idProspect;
      this.configService.recherche = 0;
    } else {
      alert('Erreur de reccuperation du prospect!');

    }
  }

  chargeDateTime() {
    this.myDate = new Date();
    this.myTime = this.myDate.getTime();
    this.conversation.Conver_Date = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.conversation.Conver_heure = this.datePipe.transform(this.myTime, 'hh:mm');
    this.conversation.Conver_Relance = 1;
  }

  submit(form) {

    console.log(form.value);
    this.configService.recherche = 1;

    this.idProspect = this.conversation.Conver_AppelId ;
    this.NiveauInters = this.conversation.Conver_Interresse ;
    this.DateDern = this.conversation.Conver_Date;

    this.appelService.creatConversation(form.value).subscribe((conversation: any)  => {
      if ( conversation == 1 ) {
        this.toastr.success('Enregistrement terminé avec succes !');
        this.loadConversation();
        this.updateNiveauinteret();
      } else {
        this.toastr.error('L\'enrgistrement à échoué !');
      }
    },() => {
      this.toastr.error('L\'enrgistrement à échoué !');
    });

  }

  loadOneAppel() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id !== '0') {
      this.appelService.readoneAppel(id).subscribe(a => this.appel = a);
    }
  }

  updateNiveauinteret() {
    const myObj = {
      id: this.idProspect,
      APPEL_NiveauInters: this.NiveauInters,
      APPEL_DATEDER: this.DateDern
    };
    const myObjStr = JSON.stringify(myObj);
    console.log('eeeeeeeee ' + myObjStr);
    this.appelService.updateNiveauinteret(myObjStr).subscribe(a => {
      this.appel = a;
      this.toastr.success('Interêt mise à jour !');
    },() => {
      this.toastr.error('Interêt n\'a pas été mis à jour !');
    });
  }

}
